export const FLOW_EXIT = 'FLOW_EXIT';
export const FLOW_NEXT = 'FLOW_NEXT';
export const FLOW_START = 'FLOW_START';
export const FLOW_SKIP_PANELS = 'FLOW_SKIP_PANELS';
export const FLOW_PREVIOUS = 'FLOW_PREVIOUS';

export const FLOW_HINT_SELECTION = 'FLOW_HINT_SELECTION';
// Note: reserve `MERGE` for merge-ui, this should be `REVIEW`
export const FLOW_MERGE_RECORD_ENTRY = 'FLOW_MERGE_RECORD_ENTRY';
// Note: reserve `MERGE` for merge-ui
export const FLOW_REVIEW_PHOTO = 'FLOW_REVIEW_PHOTO';
export const FLOW_REVIEW_RECORD = 'FLOW_REVIEW_RECORD';
export const FLOW_REVIEW_STORY = 'FLOW_REVIEW_STORY';

// variant2 full-page merge experience
export const FLOW_REVIEW_RECORD_V2 = 'FLOW_REVIEW_RECORD_V2';
export const FLOW_REVIEW_RECORD_V2_REVIEW = 'FLOW_REVIEW_RECORD_V2_REVIEW';
export const FLOW_E2E_ONBOARDING = 'FLOW_E2E_ONBOARDING';

// Save to ancestry
export const FLOW_SOURCE_PM3 = 'FLOW_SOURCE_PM3';
export const FLOW_SOURCE_PM3_MERGE = 'FLOW_SOURCE_PM3_MERGE';

// Sidebar member tree flow (Member connect)
export const FLOW_REVIEW_MEMBER_TREE = 'FLOW_REVIEW_MEMBER_TREE';
export const FLOW_REVIEW_TREE_COMPARE = 'FLOW_REVIEW_TREE_COMPARE';

// Full-page merge-ui client support
export const FLOW_FULL_PAGE_RECORD_ENTRY = 'FLOW_FULL_PAGE_RECORD_ENTRY';
export const FLOW_FULL_PAGE_MEMBER_TREE_ENTRY = 'FLOW_FULL_PAGE_MEMBER_TREE_ENTRY';
export const FLOW_FULL_PAGE_MEMBER_TREE = 'FLOW_FULL_PAGE_MEMBER_TREE';

// View record details page non-sidebar view component
export const FLOW_RECORD_COMPARE_DETAILS = 'FLOW_RECORD_COMPARE_DETAILS';

// Sidebar new person hint support
export const FLOW_NEW_PERSON_HINTS = 'FLOW_NEW_PERSON_HINTS';

export const FLOW_FULL_PAGE_SINGLE_STEP_MERGE_UX = 'FLOW_FULL_PAGE_SINGLE_STEP_MERGE_UX';

// Add Suggestions
export const FLOW_ADD_SUGGESTIONS = 'FLOW_ADD_SUGGESTIONS';
export const FLOW_ADD_SUGGESTIONS_WITH_MEDIA = 'FLOW_ADD_SUGGESTIONS_WITH_MEDIA';
export const FLOW_ADD_SUGGESTIONS_WITHOUT_MEDIA = 'FLOW_ADD_SUGGESTIONS_WITHOUT_MEDIA';
export const FLOW_ADD_SUGGESTIONS_MEDIA = 'FLOW_ADD_SUGGESTIONS_MEDIA';

// For checking if a flow is full page
export const FULL_PAGE = 'FULL_PAGE';
//ProTool
export const FLOW_PRO_TOOLS_ONBOARDING = 'FLOW_PRO_TOOLS_ONBOARDING';
export const FLOW_PRO_TOOLS_ONBOARDING_UPDATE_ACTIVE_TREE = 'FLOW_PRO_TOOLS_ONBOARDING_UPDATE_ACTIVE_TREE';
export const FLOW_PRO_TOOLS_ONBOARDING_UPDATE_MEPID = 'FLOW_PRO_TOOLS_ONBOARDING_UPDATE_MEPID';
export const FLOW_PRO_TOOLS_ONBOARDING_CHOOSE_PERSON = 'FLOW_PRO_TOOLS_ONBOARDING_CHOOSE_PERSON';
export const FLOW_PRO_TOOLS_ONBOARDING_COMPLETE = 'FLOW_PRO_TOOLS_ONBOARDING_COMPLETE';

// New person flow
export const FLOW_NEW_PERSON = 'FLOW_NEW_PERSON'; // Experiment: tree_compare_mvp cleanup

export default {
	FLOW_HINT_SELECTION,
	FLOW_MERGE_RECORD_ENTRY,
	FLOW_REVIEW_PHOTO,
	FLOW_REVIEW_RECORD,
	FLOW_REVIEW_RECORD_V2,
	FLOW_REVIEW_RECORD_V2_REVIEW,
	FLOW_E2E_ONBOARDING,
	// Save to ancestry
	FLOW_SOURCE_PM3,
	FLOW_SOURCE_PM3_MERGE,
	FLOW_REVIEW_STORY,
	FLOW_FULL_PAGE_RECORD_ENTRY,
	FLOW_FULL_PAGE_MEMBER_TREE_ENTRY,
	FLOW_FULL_PAGE_MEMBER_TREE,
	FLOW_NEW_PERSON_HINTS,
	FLOW_EXIT,
	FLOW_NEXT,
	FLOW_START,
	FLOW_PREVIOUS,
	FLOW_RECORD_COMPARE_DETAILS,
	FLOW_ADD_SUGGESTIONS,
	FLOW_ADD_SUGGESTIONS_WITH_MEDIA,
	FLOW_ADD_SUGGESTIONS_WITHOUT_MEDIA,
	FLOW_ADD_SUGGESTIONS_MEDIA,
	FULL_PAGE,
	FLOW_FULL_PAGE_SINGLE_STEP_MERGE_UX,
	FLOW_PRO_TOOLS_ONBOARDING,
	FLOW_PRO_TOOLS_ONBOARDING_UPDATE_ACTIVE_TREE,
	FLOW_PRO_TOOLS_ONBOARDING_UPDATE_MEPID,
	FLOW_PRO_TOOLS_ONBOARDING_CHOOSE_PERSON,
	FLOW_PRO_TOOLS_ONBOARDING_COMPLETE,
	FLOW_NEW_PERSON
};
